import Tone from 'tone';
import MidiEffect from '../MidiEffect.js';
import ParameterContext from 'effects/ParameterContext.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import VariableEffect from './VariableEffect.js';
import Tidalable from './Tidalable.js';

class ScriptingEffect extends Tidalable(VariableEffect(MidiEffect)) {
    constructor(name, track) {
        super(name, track);
        this.myScript = () => [];
        this.isScript = true;
    }

    onNewStep() {
        if (this.triggers.length > 0) {
            this.triggers.length = 0;
        }
    }

    get currentStep() {
        return this.track.sequencerEngine.trackStep % this.track.length;
    }

    output(time, stepNumber=this.currentStep, actualStepNumber=this.currentStep) {
        try {
            this.currentTime = time;
            this.actualStepNumber = actualStepNumber;
            if (!time) {
                this.triggers.forEach(
                    t => t.stepNumber = actualStepNumber);
            }
            if (this.myScript === undefined) {
                return this.triggers;
            }
            let ret = this.script(
                this.triggers,
                stepNumber,
                time,
                this);
            this.graphics = [];
            ret.forEach(({stepData, graphics}) => {
                if (stepData) {
                    if (!this._subSequence) {
                        stepData.track = this.track;
                    }
                }
                if (graphics) {
                    this.graphics.push(graphics);
                }
            });
            return ret;
        } catch (e) {
            console.log('error w script=', e);
            return [];
        }
    }

    get script() {
        return this.myScript;
    }

    isRealTime() {
        return false;
    }
}

export default ScriptingEffect;
